import { render, staticRenderFns } from "./HowToUse.vue?vue&type=template&id=afe4429c"
import script from "./HowToUse.vue?vue&type=script&lang=js"
export * from "./HowToUse.vue?vue&type=script&lang=js"
import style0 from "./HowToUse.vue?vue&type=style&index=0&id=afe4429c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports